<template>
    <div class="user-list" v-show="!isHideUserList" :class="{'mini-chat-list': miniChat, 'info-active': (isTablet && !!currentUserUuid && !isMobile) || ifActiveUserInfo}">
      <div class="user-list__mini-chat-header" v-if="miniChat">
        <div class="user-list__mini-chat-header-left">
          {{ $t("Chats") }}
          <span class="user-list__mini-chat-header-count" v-if="countUnreadConversation">{{ countUnreadConversation }}</span>
        </div>
        <div class="user-list__mini-chat-header-right">
          <a href="/chats" class="link-to-chat">
            <svg v-once class="wc-i" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6"/><path d="m21 3-7 7"/><path d="m3 21 7-7"/><path d="M9 21H3v-6"/></svg>              
          </a>
          <span class="close-mini-chat-vue" @click="$emit('close-mini-chat')">
            <svg v-once class="wc-i" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>              
          </span>
        </div>
      </div>
        <div class="user-list__top" v-if="isMobile || (isTablet && currentUserUuid === '') || (!ifActiveUserInfo && !isTablet)">
          <div class="user-list__top-title" v-if="!miniChat">
            <div class="user-list__top-back" v-if="isMobile" @click="btnBack">
              <svg v-once class="wc-i" aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg> 
            </div>
            <h1>{{ $t("Messages") }}</h1>
            <ModalTooltipMuteRead
              :testUrlQuickChat="testUrlQuickChat"
              :isMuteChatProp="isMuteChat"
              :isMobile="isMobile"
              :isTablet="isTablet"
              @mark-all-read="markAllRead"
              @mute-users="muteUsersFun"/>
          </div>
          <div class="user-list__top-search">
            <div class="search">
              <div class="input-placeholder" v-if="!inputValue" v-html="$t('Search by {tag}', { tag: '<b>' + $t('Username', { ns: 'cart' }) + '</b>' })"></div>
              <button type="button" :class="{'focus': ifFocusInput}">
                  <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg>
              </button>
              <input id="id" type="text" class="input-lg form-control filter-search-input" 
                autocomplete="off" 
                maxlength="50" 
                :class="{ 'js-loaded': inputValue !== '' }" ref="input"
                v-model="inputValue"
                  @input="onInput"
                  @focus="focusInput()"
                  @blur="ifFocusInput = false">
              <div class="filters-custom__search-filter-close" :class="{'active': ifShowClearInput}" @click="clearInput()"></div>
            </div>
          </div>
          <SlideUpDown :isActive="!!chatsList.length">
            <div class="user-list__top-tabs">
              <TabsIndicator
                :tabs="visibleTabs"
                :activeTab="activeTab"
                @tab-changed="handleTabChange" 
              />
            </div>
          </SlideUpDown>
        </div>
        <ScrollFade v-if="ifSkeletonListOn" class="user-list__list faded" fade-top-class="faded-top" fade-bottom-class="faded">
          <div class="chat-user skeleton-list" v-for="index in 10" :key="index">
            <div class="chat-user__img skeleton"></div>
            <div class="chat-user__info">
              <div class="chat-user__info-top">
                <span class="user-name skeleton"></span>
                <div class="user-time skeleton"></div>
              </div>
              <div class="chat-user__info-bottom">
                <p class="user-msg skeleton"></p>
                <p class="user-pinned skeleton"></p>
              </div>
            </div>
          </div>
        </ScrollFade>
        <ScrollFade v-else class="user-list__list" ref="chatUserList" fade-top-class="faded-top" fade-bottom-class="faded">
          <!-- Conversations request failed -->
          <div class="user-list__result-text empty" v-if="isLoadError && !chatsList.length">
            <div class="user-list__result-text-empty">
              <svg v-once class="wc-i" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>
              <div class="title">{{ $t("Couldn't load chats") }}</div>
              <p>{{ $t("Check your connection and try again.") }}</p>
              <button type="button" class="user-list__retry" @click="retryLoadConversations">{{ $t("Try again") }}</button>
            </div>
          </div>
          <div class="user-list__result-text is-search" :class="{'empty': responseCountList === 0}" v-if="responseCountList === 0 && userIsSearch">
            <div class="user-list__result-text-empty">
              <svg v-once class="wc-i" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/><path d="M8 11h6"/></svg>
              <div class="title">{{ $t("No results for your search") }}</div>
              <p>{{ $t("The request you were looking for was not found.") }}</p>
              <p>{{ $t("Try refining your request") }}.</p>
            </div>
          </div>
          <div class="chat-user" v-else
            :class="{'pinned' : chat.is_pinned, 'active' : currentUserUuid === chat.uuid && !miniChat && !isMobile, 'unread': !chat.is_read && chat?.last_message?.user_id !== userMy.id}"
            v-for="(chat, index) in filteredChats"
            :key="chat.uuid || index"
            :data-uuid="chat.uuid"
            @contextmenu.prevent="handleRightClick($event, chat.uuid)"
            @touchstart="handleTouchStart($event, chat.uuid)"
            @touchend="handleTouchEnd($event, chat.uuid)"
            @touchcancel="handleTouchEnd"
            @mouseleave="hideTooltip(chat.uuid)"
            @click="ChoseUser(chat.uuid)"
            >
            <div class="chat-user__tooltip" @mouseleave="hideTooltip(chat.uuid)" v-if="tooltipVisible === chat.uuid">
              <div class="tooltip-body__row pin" @click.stop="userPin(chat.uuid)">
                  <BaseIcon :name="'conversation-is-pinned'" size="25"/>                 
                  <p v-if="chat.is_pinned">{{ $t("Unpin chat") }}</p>
                  <p v-else>{{ $t("Pin chat") }}</p>
              </div>
              <MuteUser @user-mute="userMute" :isUserMute="chat.is_mute" :userId="chat.uuid" :longText="false"/>
              <ReportUser :userId="chat.uuid" :miniChat="miniChat"/>
            </div>
            <div class="chat-user__wrap" :class="{swiped: tooltipVisibleSwipe === chat.uuid && isTablet}">
              <div class="chat-user__img" v-if="chat.user?.avatar || !chat.user?.username">
                <ChatAvatar :url="chat.user?.avatar || ''" :name="chat.user?.username || ''" :supportName="supportName" :size="isMobile ? 44 : 40"/>
                <span v-if="!isMobile &&!chat.is_read && chat?.last_message?.user_id !== userMy.id && (ifActiveUserInfo || (isTablet && !!currentUserUuid))" class="user-count">1</span>
                <span v-else-if="!isMobile && chat.is_pinned && (ifActiveUserInfo || (isTablet && !!currentUserUuid))" class="user-pinned">
                  <BaseIcon :name="'conversation-is-pinned'" size="16"/>
                </span>
                <div v-else class="online-status">
                  <div class="ico-user-status" :class="{'online': chat.user?.username ? chat.user.is_online : true }"></div>
                </div>
              </div>
              <div class="chat-user__img skeleton" v-else></div>
              <transition name="user-info">
                <div class="chat-user__info" v-if="isMobile || (!ifActiveUserInfo && !isTablet) || (isTablet && currentUserUuid === '')">
                  <div class="chat-user__info-top">
                    <span class="user-name">
                      <span>{{chat.user?.username ? chat.user.username : supportName}}</span>
                      <svg v-if="!chat.user?.username" class="wc-i is-official" role="img" :aria-label="$t('Official')" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></svg>
                      <BaseIcon v-if="chat.is_mute" :name="'conversation-is-mute'" size="16"/> 
                    </span>
                    <div class="top-right">
                      <span v-if="chat?.last_message && chat?.last_message?.user_id === userMy.id" class="user-last-msg" :class="{'readed': chat.last_message.is_read}">
                        <BaseIcon :name="'message-is-read'" size="16"/> 
                      </span>
                      <span class="user-time">{{formatMessageDate(chat.updated_at)}}</span>
                    </div>
                  </div>
                  <div class="chat-user__info-bottom">
                    <p class="user-msg">
                      <span v-if="chat?.isTyping" class="not-msg">{{ $t("Typing...") }}</span>
                      <template v-else-if="chat?.last_message">
                        <svg v-if="lastMsgKind(chat) === 'system'" class="wc-i user-msg__icon is-system" aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
                        <svg v-else-if="lastMsgKind(chat) === 'image'" class="wc-i user-msg__icon" aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="18" x="3" y="3" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/></svg>
                        <svg v-else-if="lastMsgKind(chat) === 'doc'" class="wc-i user-msg__icon" aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/></svg>
                        <span v-if="lastMsgKind(chat) === 'system'" :class="{unrid: !chat.is_read}">{{ $t("System message") }}</span>
                        <span v-else :class="{unrid: !chat.is_read && chat?.last_message?.user_id !== userMy.id}" v-html="safeLastMessage(chat)"></span>
                      </template>
                      <span v-else class="not-msg">{{ $t("No messages yet") }}</span>
                    </p>
                    <div class="user-right-icon">
                      <span v-if="!chat.is_read && chat?.last_message?.user_id !== userMy.id" class="user-count">1</span>
                      <span v-if="chat.is_pinned" class="user-pinned">
                        <BaseIcon :name="'conversation-is-pinned'" size="16"/>
                      </span>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="chat-user__btn-mobile" :class="{active: tooltipVisibleSwipe === chat.uuid}" v-if="isTablet">
              <div class="tooltip-body__row pin" @click.stop="userPin(chat.uuid)">
                <BaseIcon :name="'conversation-is-pinned'" size="25"/>                  
              </div>
              <MuteUser @user-mute="userMute" :isUserMute="chat.is_mute" :userId="chat.uuid" :longText="false"/>
            </div>
          </div>
          <!-- Unread / Pinned tab with nothing in it -->
          <div class="user-list__result-text empty is-tab" v-if="!userIsSearch && responseCountList !== 0 && activeTab !== 1 && !filteredChats.length">
            <div class="user-list__result-text-empty">
              <svg v-if="activeTab === 2" class="wc-i" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 7 17l-5-5"/><path d="m22 10-7.5 7.5L13 16"/></svg>
              <svg v-else class="wc-i" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M12 17v5"/><path d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z"/></svg>
              <div class="title">{{ activeTab === 2 ? $t("No unread chats") : $t("No pinned chats") }}</div>
              <p>{{ activeTab === 2 ? $t("You're all caught up. New messages will appear here.") : $t("Pin a chat from its menu to keep it at the top.") }}</p>
            </div>
          </div>
          <div class="user-list__result-text" :class="{'empty': responseCountList === 0}" v-if="responseCountList === 0 && !userIsSearch">
            <div v-if="responseCountList === 0" class="user-list__result-text-empty">
              <svg v-once class="wc-i" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z"/><path d="M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1"/></svg>
              <p>{{ $t("No conversations found") }}</p>
            </div>
            <span v-else>{{ $t('{count} results were found', {count: responseCountList}) }}</span>
          </div>
        </ScrollFade>
    </div>
  </template>
  
<script>
  import ChatAvatar from './ChatAvatar.vue';
  import { SimpleSound } from '/webpack-assets/vue/utils/simpleSound.js';
  import axios from '/webpack-assets/vue/config/axios-config';
  import ScrollFade from '/webpack-assets/vue/components/ScrollFade.vue';
  import ModalTooltipMuteRead from './ModalTooltipMuteRead.vue';
  import MuteUser from './MuteUser.vue';
  import ReportUser from './ReportUser.vue';
  import BaseIcon from '/webpack-assets/vue/components/BaseIcon.vue';
  import TabsIndicator from '/webpack-assets/vue/templates/chat/parts/ChatTabsIndicator.vue';
  import SlideUpDown from '/webpack-assets/vue/templates/chat/parts/ChatSlideUpDown.vue'
  import { renderAlertVue } from '/webpack-assets/vue/utils/common.js';
  import { chatFetch } from './chatTokenManager';
  import { escapeHtml } from '/webpack-assets/vue/utils/escapeHtml.js';
  import { decodeHtmlEntities } from '/webpack-assets/vue/utils/decodeHtmlEntities.js';

  const __lastMsgCache = new Map();
  function truncateUnicode(str, maxLength) {
    const chars = Array.from(str);
    return chars.length > maxLength
      ? chars.slice(0, maxLength).join('') + '…'
      : str;
  }
  function collapseLineBreaks(text) {
    return text
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/\r\n|\r|\n/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }
  function stripHtmlTags(text) {
    return text.replace(/<[^>]*>/g, '');
  }
  export default {
    components: {
      ChatAvatar,
      ScrollFade,
      ModalTooltipMuteRead,
      MuteUser,
      ReportUser,
      BaseIcon,
      TabsIndicator,
      SlideUpDown
    },
    data() {
      return {
        inputValue: '',
        touchStartX: 0,
        touchStartY: 0,
        ifFocusInput: false,
        ifShowClearInput: false,
        searchTimeout: null,
        touchTimeout: null,
        isLoadingChats: false,
        // first "all" request failed (network, token, non-JSON answer)
        isLoadError: false,
        // first non-search "all" request finished successfully
        isListLoaded: false,
        chatsStore: new Map(),
        chatsList: [],
        lastTimemarkList: null,
        chatsPinnedList: [],
        chatsUnreadList: [],
        chatsListIsMute: [],
        responseCountList: null,
        lastResponseCount: null,
        beforeRequestTimemark: null,
        userMy: window?.common.user,
        isMuteChat: window.header?.chat?.is_mute,
        usersInfoCache: new Map(),
        tooltipVisible: null,
        tooltipVisibleSwipe: null,
        userIsSearch: false,
        supportImg: '/img/icons/logo-small.svg',
        supportName:  'WYREL',
        ifSkeletonListOn: true,
        isScrollNearBottom: true,
        _scrollAttached: false,
        _onUserListScroll: null,
        _scrollRaf: null,
        isHideUserList: false,
        activeTab: 1,
        chatSound: null,
        tabsList: [
          {id: 1, name: this.$t('All'), isShow: true},
          {id: 2, name: this.$t('Unread'), isShow: true},
          {id: 3, name: this.$t('Pinned'), isShow: true}
        ],
      };
    },
    props: {
      testUrlQuickChat: {
        type: String,
        default: ''
      },
      usersListAll: {
        type: Array,
        default: () => []
      },
      currentUserUuid: {
        type: String,
        required: true
      },
      ifActiveUserInfo: {
        type: Boolean,
        default: false
      },
      isTablet: {
        type: Boolean,
        default: false
      },
      isMobile: {
        type: Boolean,
        default: false
      },
      language: {
        type: String,
        default: 'en'
      },
      countUnreadConversation: {
        type: Number,
        default: 0
      },
      isActiveConversiation: {
        type: Boolean,
        default: false,
      },
      isActiveNewMsgConversation: {
        type: Boolean,
        default: false,
      },
      miniChat: {
        type: Boolean,
        default: false
      },
      isLoadingMessages: {
        type: Boolean,
        default: false
      }
    },
    mounted() {
      if(this.usersListAll.length && this.miniChat) {

        if(this.usersListAll.length === 1) {
          this.getUsersInfo('all', [this.usersListAll[0].id]);
          this.$emit('is-hide-user-list', true);
          if (!this.miniChat) this.isHideUserList = true;
        }
        this.chatSound = new SimpleSound({
            src: ['/sounds/sound_message.mp3'],
            volume: 0.7,
            onplayerror: (id, err) => {
                console.warn('Chat sound blocked:', err);
            },
        });
        this.chatsList = (this.usersListAll || []).map(chat => this.normalizeChat(chat));
        this.responseCountList = this.chatsList.length;
        this.lastTimemarkList = this.chatsList.length
              ? this.chatsList[this.chatsList.length - 1].timemark || ''
              : '';
        this.isScrollNearBottom = true;
        this.getUsersInfo('all');
      }
    },
    beforeUnmount() {
      this._detachScrollListener();
    },
    computed: {
      visibleTabs() {
        return this.tabsList.map(tab => {
          if (tab.id === 2) {
            return { ...tab, isShow: true, count: this.countUnreadConversation };
          }
          return { ...tab, isShow: true };
        });
      },
      filteredChats() {
        switch (this.activeTab) {
          case 2:
            return this.chatsUnreadList.filter(chat => !chat.is_read);

          case 3:
            return this.chatsPinnedList;

          default:
            return this.chatsList;
        }
      },
      hasNoConversations() {
        return this.isListLoaded && !this.isLoadError && !this.userIsSearch && this.chatsList.length === 0;
      },
      allChats() {
        const combined = new Map();
        this.chatsPinnedList.forEach(chat => combined.set(chat.uuid, chat));
        this.chatsUnreadList.forEach(chat => combined.set(chat.uuid, chat));
        this.chatsList.forEach(chat => combined.set(chat.uuid, chat));
        return Array.from(combined.values());
      }
    },
    watch: {
      hasNoConversations: {
        immediate: true,
        handler(val) {
          this.$emit('no-conversations', val);
        }
      },
      ifActiveUserInfo(bool) {
        if(bool) this.activeTab = 1;
      },
      countUnreadConversation(val) {
        if (!val) {
          this.activeTab = 1;
          this.chatsUnreadList = [];
        }
      }
    },
    methods: {
      onImgError(event) {
        event.target.src = this.supportImg;
      },
      handleTabChange(id) {
        this.activeTab = id;
        if (id === 2 && this.chatsUnreadList.length === 0) {
          this.getConversations('unread');
        }
      },
      async handleChatMessage(socketData, isUpdate = false) {
        if (this.inputValue !== '') return;

        const uuid = socketData.conversation.uuid;
        let conversation = this.chatsListIsMute.find(c => c.uuid === uuid);
        let isMute = conversation?.is_mute;

        if (isMute === undefined) {
          isMute = await this.checkConversationMute(uuid);
          this.chatsListIsMute.push({ uuid, is_mute: isMute });
        }

        this.updateOrCreateChatFromSocket(socketData);

        if (
          !isMute &&
          !this.isMuteChat &&
          socketData.message.user_id !== this.userMy.id &&
          !isUpdate
        ) {
          try {
            if (this.chatSound) {
              this.chatSound.stop();
              const playPromise = this.chatSound.play();

              if (playPromise && typeof playPromise.catch === 'function') {
                  playPromise.catch((err) => {
                      console.warn('Sound blocked (mute check):', err);
                  });
              }
            }
          } catch (error) {
            console.warn('Audio init failed:', error);
          }
        }
      },
      updateOrCreateChatFromSocket(socketData) {
        const { conversation, message } = socketData;
        const uuid = conversation.uuid;

        const { user: extractedUser, is_pinned } = this.extractChatUser(conversation);
        const pinnedFlag = Boolean(is_pinned);

        const index = this.chatsList.findIndex(c => c.uuid === uuid);

        const isMyMessage = message.user_id === this.userMy.id;
        const isActiveChat = this.currentUserUuid === uuid;
        const isRead = isMyMessage || isActiveChat;
        if (index !== -1) {
          let chat = this.chatsList[index];

          if (Array.isArray(message.edits) && message.edits.length > 0) {
            if (chat.last_message && chat.last_message.id === message.id) {
              chat.last_message = message;
              const cacheKey = message.id || message.timemark;
              if (cacheKey && __lastMsgCache.has(cacheKey)) {
                __lastMsgCache.delete(cacheKey);
              }

              this.chatsList.splice(index, 1, { ...chat });
            }
            return chat;
          }

          chat = {
            ...chat,
            last_message: message,
            updated: conversation.updated_at || message.created_at,
            timemark: message.timemark,
            is_read: isRead,
            is_pinned: pinnedFlag,
          };

          if (!isRead || this.miniChat) {
            this.chatsUnreadList = [
              { ...chat },
              ...this.chatsUnreadList.filter(c => c.uuid !== uuid),
            ];
          } else {
            this.chatsUnreadList = this.chatsUnreadList.filter(c => c.uuid !== uuid);
          }

          this.chatsStore.set(uuid, chat);
          this.chatsList = Array.from(this.chatsStore.values()).sort((a, b) => {
            if (a.is_pinned && !b.is_pinned) return -1;
            if (!a.is_pinned && b.is_pinned) return 1;
            const aTime = a.last_message?.timemark || a.timemark || 0;
            const bTime = b.last_message?.timemark || b.timemark || 0;
            return bTime - aTime;
          });
          this.chatsPinnedList = this.chatsList.filter(c => c.is_pinned);

          return chat;
        } else {
          const newChat = {
            uuid,
            timemark: message.timemark,
            updated_at: conversation.updated_at || message.created_at,
            last_message: message,
            is_pinned: pinnedFlag,
            is_mute: false,
            is_read: isRead,
            user: {
              avatar: null,
              id: extractedUser.id,
              img: null,
              is_online: false,
              last_seen: null,
              link_profile: null,
              public_profile_url: null,
              username: extractedUser.username,
              country: null,
              timezone_offset: null,
              verify_css_class: null,
            }
          };

          this.chatsStore.set(newChat.uuid, newChat);
          if (!isRead) {
            this.chatsUnreadList = [
              { ...newChat },
              ...this.chatsUnreadList.filter(c => c.uuid !== uuid),
            ];
          } else {
            this.chatsUnreadList = this.chatsUnreadList.filter(c => c.uuid !== uuid);
          }

          this.chatsList = Array.from(this.chatsStore.values()).sort((a, b) => {
            if (a.is_pinned && !b.is_pinned) return -1;
            if (!a.is_pinned && b.is_pinned) return 1;
            const aTime = a.last_message?.timemark || a.timemark || 0;
            const bTime = b.last_message?.timemark || b.timemark || 0;
            return bTime - aTime;
          });
          this.chatsPinnedList = this.chatsList.filter(c => c.is_pinned);
          this.getUsersInfo('all');
          
          if(!this.miniChat) this.isHideUserList = this.chatsList.length === 1;
          this.$emit('is-hide-user-list', this.chatsList.length === 1);
          return newChat;
        }
      },
      extractChatUser(conversation) {
        const users = conversation?.users || {};
        const myUserId = String(this.userMy.id);
        const myUser = users[myUserId];
        const otherUserId = Object.keys(users).find(id => id !== myUserId);
        const otherUserRaw = users[otherUserId];
        
        return {
          user: this.normalizeUser(otherUserRaw, Number(otherUserId)),
          is_pinned: Boolean(myUser?.is_pinned),
          is_read: Boolean(myUser?.is_read),
        };
      },
      normalizeUser(user, fallbackId = null) {
        return {
          id: user?.id ?? fallbackId,
          username: user?.username || 'Support',
          img: user?.img ?? '/img/avatar/active/avatar-8.webp',
          is_online: Boolean(user?.is_online),
          link_profile: user?.link_profile ?? null,
          referrer: user?.referrer || null,
        };
      },
      async checkConversationMute(conversationUuid) {
          try {
              const { data } = await axios.post(
                  '/chat-api/conversation-is-mute',
                  { conversation_uuid: conversationUuid },
                  { headers: {
                          Accept: 'application/json',
                          'Content-Type': 'application/json'
                      }
                  }
              );
              if(data?.status === 'success') {
                return Boolean(data.data.is_mute);
              } else {
                return false;
              }
          } catch (e) {
              console.error('Mute check error', e);
              return false;
          }
      },
      btnBack() {
        window.history.back();
      },
      // Preview icon kind for the last message (design: info icon for system, image / file icons)
      lastMsgKind(chat) {
        const msg = chat?.last_message;
        if (!msg) return '';
        if (msg.type && msg.type !== 1) return 'system';
        if ((!msg.text || msg.text.trim() === '') && Array.isArray(msg.files) && msg.files.length > 0) {
          const name = msg.files[msg.files.length - 1].original_name || '';
          const ext = (name.split('.').pop() || '').toLowerCase();
          return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'].includes(ext) ? 'image' : 'doc';
        }
        return '';
      },
      safeLastMessage(chat) {
        const msg = chat?.last_message;
        if (!msg) return '';

        const key = msg.id || msg.timemark;
        if (key && __lastMsgCache.has(key)) {
          return __lastMsgCache.get(key);
        }
        let result = '';

        if (msg.text && msg.text.trim() !== '') {
          const decoded = decodeHtmlEntities(String(msg.text));
          const plain = stripHtmlTags(collapseLineBreaks(decoded));
          const truncated = truncateUnicode(plain, 43);
          result = escapeHtml(truncated);
        } else if (Array.isArray(msg.files) && msg.files.length > 0) {
          const lastFile = msg.files[msg.files.length - 1];
          const name = lastFile.original_name || '';
          const ext = (name.split('.').pop() || '').toLowerCase();
          const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];

          result = imageExts.includes(ext) ? this.$t("Image") : this.$t("Document");
        }

        if (key) __lastMsgCache.set(key, result);
        return result;
      },
      muteUsersFun(bool){
        this.$emit('mute-users', bool);
        this.isMuteChat = bool;
      },
      markAllRead() {
        this.chatsStore.forEach(chat => {
          chat.is_read = true;
        });
        this.chatsList.forEach(chat => {
          chat.is_read = true;
        });
        this.chatsPinnedList.forEach(chat => {
          chat.is_read = true;
        });
        this.activeTab = 1;
        this.chatsUnreadList = [];
        // the unread counter lives in chat.vue and is otherwise updated only by the socket
        this.$emit('mark-all-read');
      },
      ChoseUser(uuid) {
        if (this.isLoadingMessages) return
        this.markRead(uuid)
        this.tooltipVisible = null;
        this.tooltipVisibleSwipe = null;
  
        this.$emit('user-id', uuid);
      },
      onInput(event) {
          let inputValue = this.inputValue;
          this.activeTab = 1;
          const cyrillicPattern = /[а-яА-ЯЁё]/;

          if (cyrillicPattern.test(inputValue)) {
              this.inputValue = inputValue.replace(cyrillicPattern, '');
          }

          if(this.inputValue !== '') {
            this.ifShowClearInput = true;
          } else {
            this.ifShowClearInput = false;
          }

          clearTimeout(this.searchTimeout);

          this.searchTimeout = setTimeout(() => {
              this.getConversations('all', false, this.inputValue);
          }, 300);
      },
      clearInput() {
        this.inputValue = '';
        this.ifShowClearInput = false;
        this.getConversations();
        this.$refs.input.classList.remove('js-loaded');
      },
      // search(query) {
      //   this.inputValue = query;
      //   this.getConversations({
      //     type: 'all',
      //     username: this.searchText
      //   });
      // },
      focusInput(){
        this.ifFocusInput = true;
        this.tooltipVisible = null;
        this.tooltipVisibleSwipe = null;
      },
      handleRightClick(event, userId) {
        let clientX, clientY;

        if (event.changedTouches && event.changedTouches.length > 0) {
          clientX = event.changedTouches[0].clientX;
          clientY = event.changedTouches[0].clientY;
        } else {
          clientX = event.clientX;
          clientY = event.clientY;
        }

        this.tooltipVisible = userId;

        this.$nextTick(() => {
          const chatUser = document.querySelector(`.chat-user[data-uuid="${userId}"]`);
          if (chatUser) {
            const tooltip = chatUser.querySelector(".chat-user__tooltip");
            tooltip?.classList.remove("top");

            if (this.isTooltipNearBottom(chatUser)) {
              tooltip?.classList.add("top");
            }
          }
        });
      },
      handleTouchStart(event, userId) {
        this.touchStartX = event.changedTouches[0].clientX;
        this.touchStartY = event.changedTouches[0].clientY;

        this.touchTimeout = setTimeout(() => {
          this.handleRightClick(event, userId);
        }, 800);
      },
      handleTouchCancel() {
        clearTimeout(this.touchTimeout);
      },
      handleTouchEnd(e, uuid) {
        const touchEndX = e.changedTouches[0].clientX;
        const touchEndY = e.changedTouches[0].clientY;

        const deltaX = this.touchStartX - touchEndX;
        const deltaY = touchEndY - this.touchStartY;

        if (Math.abs(deltaY) < 40 && deltaX > 50) {
          this.tooltipVisibleSwipe = uuid;
          clearTimeout(this.touchTimeout);
        } else if (deltaX < -50) {
          this.tooltipVisibleSwipe = null;
          clearTimeout(this.touchTimeout);
        } else {
          clearTimeout(this.touchTimeout);
        }
      },
      isTooltipNearBottom(chatUser) {
        const rect = chatUser.getBoundingClientRect();
        const distanceToBottom = window.innerHeight - rect.bottom;
        return distanceToBottom < 180;
      },
      hideTooltip(userId) {
        const chatUser = document.querySelector(`.chat-user[data-uuid="${userId}"]`);
        if (this.tooltipVisible === userId) {
          this.tooltipVisible = null;
          this.tooltipVisibleSwipe = null;
          if (chatUser) {
            const tooltip = chatUser.querySelector(".chat-user__tooltip");
            if (tooltip) {
              tooltip.classList.remove("top");
            }
          }
        }
        
      },
      userMute(uuid, isMute, ifNeedEmit = true) {
        this.tooltipVisible = null;
        this.tooltipVisibleSwipe = null;

        const user = this.chatsStore.get(uuid);
        const userMute = this.chatsListIsMute.find(user => user.uuid === uuid);
        
        if(ifNeedEmit) {
          this.$emit('user-mute', {
            userId: uuid,
            isMute: isMute
          });
        }

        if (user) {
            user.is_mute = isMute;
        }
        if (userMute) {
            userMute.is_mute = isMute;
        }
      },
      async markRead(uuid) {
        const chat = this.chatsStore.get(uuid);
        if (chat && chat.last_message?.user_id !== this.userMy.id) {
          chat.is_read = true;

          const index = this.chatsList.findIndex(c => c.uuid === uuid);
          if (index !== -1) {
            this.chatsList[index] = { ...chat };
          }

          this.chatsUnreadList = this.chatsUnreadList.filter(c => c.uuid !== uuid);
        }

        try {
          const response = await axios.post('/chat-api/mark-read', { uuid });

          if (response?.data?.status !== 'success') {
            console.warn('markRead failed response:', response?.data);
          }

        } catch (error) {
          if (
            error?.code === 'ERR_NETWORK' ||
            error?.message?.includes('Network Error')
          ) {
            console.warn('markRead network error ignored');
            return;
          }

          console.error('markRead error:', error);
        }
      },
      userPin(uuid) {
        this.tooltipVisible = null;
        this.tooltipVisibleSwipe = null;

        axios.post('/chat-api/switch-conversation-pin', { uuid })
          .then(response => {
            if (response.data.status === 'success') {
              const chat = this.chatsStore.get(uuid);
              if (!chat) return;

              if (response.data.data === 'reach_limit') {
                renderAlertVue(this.$t("You can't pin more than 10 chats to the top."), 'danger', 2000);
                return;
              }

              chat.is_pinned = response.data.data === 'on';
              this.chatsList = Array.from(this.chatsStore.values())
                .sort((a, b) => {
                  if (a.is_pinned && !b.is_pinned) return -1;
                  if (!a.is_pinned && b.is_pinned) return 1;
                  const aTime = a.last_message?.timemark || a.timemark || 0;
                  const bTime = b.last_message?.timemark || b.timemark || 0;
                  return bTime - aTime;
                });

              this.chatsPinnedList = this.chatsList.filter(c => c.is_pinned);

              if (this.chatsPinnedList.length === 0 && this.activeTab === 3) {
                this.activeTab = 1;
              }

              const last = this.chatsList[this.chatsList.length - 1];
              this.lastTimemarkList = last?.timemark || '';
            }
          })
          .catch(error => {
            console.error('Error response:', error);
          });
      },
      handleScroll() {
        this.tooltipVisible = null;
        if(this.chatsList.length < 25) return

        const ref = this.$refs.chatUserList;
        const chatUserListEl = ref?.$el || ref;
        if (!chatUserListEl) return;
        const scrollSum = chatUserListEl.scrollTop + chatUserListEl.clientHeight;
        const scrollHeight = chatUserListEl.scrollHeight;
        if (scrollSum >= scrollHeight - 180 && this.isScrollNearBottom) {
          if (this.lastTimemarkList === '') return
          const type = this.activeTab === 2 ? 'unread' : 'all'
          this.getConversations(type, true);
          this.isScrollNearBottom = false
        }
      },
      _attachScrollListener() {
        const ref = this.$refs.chatUserList;
        const el = ref?.$el || ref;
        if (!el || this._scrollAttached) return;
        this._onUserListScroll = () => {
          if (this._scrollRaf) return;
          this._scrollRaf = requestAnimationFrame(() => {
            try { this.handleScroll({ target: el }); } finally { this._scrollRaf = null; }
          });
        };
        el.addEventListener('scroll', this._onUserListScroll, { passive: true });
        this._scrollAttached = true;
      },
      _detachScrollListener() {
        const ref = this.$refs.chatUserList;
        const el = ref?.$el || ref;
        if (el && this._onUserListScroll) {
          try { el.removeEventListener('scroll', this._onUserListScroll); } catch(e) {}
        }
        if (this._scrollRaf) {
          cancelAnimationFrame(this._scrollRaf);
          this._scrollRaf = null;
        }
        this._scrollAttached = false;
        this._onUserListScroll = null;
      },
      normalizeChat(chat) {
        const myId = String(this.userMy.id);
        const users = Object.entries(chat.users || {});
        const myData = users.find(([id]) => id === myId)?.[1];
        const [otherUserId, otherUser] = users.find(([id]) => id !== myId) || [null, null];
        let lastMessage = null;

        if(myData.last_message && myData.last_message.type !== 1) {
          lastMessage = myData.last_message;
        } else {
          const lastMessages = users.map(([, u]) => u.last_message).filter(Boolean);
          lastMessage = lastMessages.sort((a, b) => b.timemark - a.timemark)[0] || null;
        }

        const chatObj = {
          uuid: chat.uuid,
          timemark: chat.timemark,
          user: otherUser
            ? {
                id: Number(otherUserId),
                username: otherUser.username || 'Support',
                img: otherUser?.avatar?.src || '/img/avatar/active/avatar-8.webp',
                avatar: otherUser?.avatar?.src || '/img/avatar/active/avatar-8.webp',
                is_online: Boolean(otherUser.is_online),
                link_profile: otherUser.public_profile_url ?? null,
                referrer: otherUser.referrer || null,
              }
            : {
                id: null,
                username: 'Support',
                img: '/img/avatar/active/avatar-8.webp',
                avatar: '/img/avatar/active/avatar-8.webp',
                is_online: true,
                link_profile: null,
              },
          is_read: myData?.is_read ?? true,
          is_pinned: myData?.is_pinned ?? false,
          is_mute: myData?.is_mute ?? false,
          last_message: lastMessage,
          updated_at: chat.updated_at,
        };

        if (this.chatsStore.has(chatObj.uuid)) {
          const existing = this.chatsStore.get(chatObj.uuid);
          Object.assign(existing, chatObj);
          return existing;
        }

        this.chatsStore.set(chatObj.uuid, chatObj);
        return chatObj;
      },
      async getConversations(request = 'all', loadMore = false, searchText = '') {
        const type = request === 'firstLoad' ? 'all' : request;

        const params = {};
        if (loadMore) {
          params.starting_before = this.lastTimemarkList;
        }

        if (searchText) {
          params.search_username = searchText;
          this.userIsSearch = true;
        } else {
          this.userIsSearch = false;
        }

        this.isLoadingChats = true;

        try {
          const query = new URLSearchParams(params).toString();

          const res = await chatFetch(
            `${this.testUrlQuickChat}conversations/${type}?${query}`
          );

          const result = await res.json();

          const chats = (result?.data || []).map(chat => this.normalizeChat(chat));

          if (type === 'all') {

            if (loadMore) {
              const existingIds = new Set(this.chatsList.map(c => c.uuid));

              const newChats = chats.filter(chat => !existingIds.has(chat.uuid) && !chat.is_pinned);

              this.chatsList = [...this.chatsList, ...newChats];
            } else {
              this.chatsList = chats;

              this.chatsList.sort((a, b) => {
                const aTime = a.last_message?.timemark || a.timemark || 0;
                const bTime = b.last_message?.timemark || b.timemark || 0;
                return bTime - aTime;
              });
            }

            
            this.responseCountList = this.chatsList.length;
            this.lastTimemarkList = this.chatsList.length
              ? this.chatsList[this.chatsList.length - 1].timemark || ''
              : '';
            this.isLoadError = false;
            if (!this.userIsSearch) this.isListLoaded = true;

            if (!this.userIsSearch) {
              this.chatsListIsMute = [...this.chatsList];
              if (!loadMore){
                this.getConversations('pinned');
              }
            }

            this.getUsersInfo('all');
            this.isScrollNearBottom = true;

            if (request === 'firstLoad') {
              if(this.responseCountList === 1) {
                if (!this.miniChat) this.isHideUserList = true;
                this.$emit('is-hide-user-list', true);
                //this.ChoseUser(this.chatsList[0].uuid);
              }

              // if(this.responseCountList > 9) {
              //   this.getConversations('pinned');
              // }
            }
            if(!!this.countUnreadConversation) {
              this.getConversations('unread');
            }
          }

          if (type === 'pinned') {
            this.chatsPinnedList = chats;
            this.getUsersInfo('pinned');

            const pinnedUuids = new Set(this.chatsPinnedList.map(chat => chat.uuid));
            this.chatsList = [
              ...this.chatsPinnedList,
              ...this.chatsList.filter(chat => !pinnedUuids.has(chat.uuid))
            ];

            if(!!this.countUnreadConversation && !this.chatsUnreadList.length) {
              this.getConversations('unread');
            }
          }

          if (type === 'unread') {
            if (loadMore) {
              this.chatsUnreadList = [...this.chatsUnreadList, ...chats];
            } else {
              this.chatsUnreadList = chats;
            }
            this.getUsersInfo('unread');
          }

          setTimeout(() => {
            this.ifSkeletonListOn = false;
            this.$nextTick(() => this._attachScrollListener());
          }, this.chatsList.length === 0 ? 200 : 0);
        } catch (e) {
          console.error('Request error:', e);
          // without this the skeleton would stay forever
          if (type === 'all' && !loadMore) {
            this.isLoadError = true;
            this.ifSkeletonListOn = false;
          }
        } finally {
          this.isLoadingChats = false;
        }
      },
      retryLoadConversations() {
        this.isLoadError = false;
        this.ifSkeletonListOn = true;
        this.getConversations('firstLoad', false, this.inputValue?.trim() || '');
      },
      async getUsersInfo(type = 'all', extraIds = []) {
        const listsMap = {
          all: this.chatsList,
          pinned: this.chatsPinnedList,
          unread: this.chatsUnreadList
        };

        const listsToUpdate = Object.values(listsMap);
        const chats = listsMap[type] || [];

        const normalizedExtraIds = extraIds
          .map(id => Number(id))
          .filter(id => Number.isFinite(id));

        if (!chats.length && !normalizedExtraIds.length) {
          this.$emit('chat-list', this.allChats);
          return;
        }

        const userIds = [
          ...new Set([
            ...chats
              .map(chat => Number(chat.user?.id))
              .filter(id => Number.isFinite(id) && !this.usersInfoCache.has(id)),
            ...normalizedExtraIds.filter(id => !this.usersInfoCache.has(id))
          ])
        ];

        if (!userIds.length) {
          this.updateChatsFromCache(listsToUpdate);
          this.$emit('chat-list', this.allChats);
          return;
        }

        try {
          const response = await axios.post('/chat-api/get-users-info', { user_ids: userIds });

          if (response.data.status !== 'success') return;

          const users = response.data.data;

          users.forEach(user => {
            if (user.id) this.usersInfoCache.set(user.id, user);
          });
          this.updateChatsFromCache(listsToUpdate);
          if (extraIds.length) {
            extraIds.forEach(id => {
              if (!this.chatsList.find(chat => chat.user?.id === id) || this.chatsList.length === 1) {
                const userInfo = this.usersInfoCache.get(id);
                //if (!userInfo) return;

                const newChat = {
                  uuid: this.currentUserUuid,
                  timemark: Date.now(),
                  updated_at: new Date().toISOString(),
                  last_message: null,
                  is_pinned: false,
                  is_mute: false,
                  is_read: true,
                  user: {
                    id: userInfo.id,
                    username: userInfo.username,
                    avatar: userInfo.avatar?.src || '/img/avatar/active/avatar-8.webp',
                    is_online: userInfo.is_online,
                    public_profile_url: userInfo.public_profile_url,
                    last_seen: userInfo.last_seen ?? null,
                    country: userInfo.country || null,
                    timezone_offset: userInfo.timezone_offset ?? null,
                    verify_css_class: userInfo.verify_css_class || null,
                    referrer: userInfo.referrer || null,
                  }
                };
                this.$emit('chat-new', newChat)
             }
            });
          }
          this.$emit('chat-list', this.allChats);
        } catch (error) {
          console.error('Error response:', error);
        }
      },
      updateChatsFromCache(lists) {
        lists.forEach(list => {
          list.forEach(chat => {
            const userId = chat.user?.id;
            let userInfo = this.usersInfoCache.get(userId);
            if (userInfo) {
              chat.user = {
                ...chat.user,
                id: userInfo.id,
                username: userInfo.username,
                avatar: userInfo.avatar?.src || '/img/avatar/active/avatar-8.webp',
                is_online: userInfo.is_online,
                public_profile_url: userInfo.public_profile_url,
                referrer: userInfo.referrer || null,
                last_seen: userInfo.last_seen ?? null,
                country: userInfo.country || null,
                timezone_offset: userInfo.timezone_offset ?? null,
                verify_css_class: userInfo.verify_css_class || null,
              };
            }
          });
        });
      },
      formatMessageDate(timestamp) {
          const date = new Date(timestamp);
          const now = new Date();

          if (date.toDateString() === now.toDateString()) {
              return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });
          }

          const daysDiff = (now - date) / (1000 * 60 * 60 * 24);
          if (daysDiff < 7 && now.getDay() >= date.getDay()) {
              return date.toLocaleDateString(this.language, { weekday: 'short' });
          }

          if (date.getFullYear() === now.getFullYear()) {
            return date.toLocaleDateString(this.language, {
              day: '2-digit',
              month: 'short'
            });
          }

          return date.toLocaleDateString(this.language, { day: '2-digit', month: '2-digit', year: '2-digit' })
              .replace(/\//g, '.')
              .replace(',', '');
      }
    }
  };
</script>
<style scoped lang="scss">
  .user-info-enter-active,
  .user-info-leave-active {
    transition: width 0.4s ease;
  }

  .user-info-enter-from,
  .user-info-leave-to {
    width: 0;
  }

  .user-info-enter-to,
  .user-info-leave-from {
    width: 100%;
  }
  .user-list{
      min-width: 320px;
      max-width: 320px;
      background-color: var(--wc-surface);
      border-right: 1px solid var(--wc-border);
      overflow: hidden;
      display: flex;
      flex-direction: column;
      font-family: var(--wc-font);
      @media only screen and (max-width: 1023px) {
        border-radius: 0;
        z-index: 1;
        height: 100%;
        max-height: 100%;
      }
      @media only screen and (max-width: 1279px) {
        min-width: 300px;
        max-width: 300px;
        transition: 0.4s;
        // Collapsed avatar rail (tablet with an open chat / narrow desktop with details open)
        &.info-active{
          min-width: 80px;
          max-width: 80px;
          .chat-user{
            justify-content: center;
            &__btn-mobile{
              display: none;
            }
            &__wrap{
              justify-content: center;
              border-radius: 12px;
            }
            &__img{
              margin: 0;
            }
          }
          .user-list__list{
            padding: 8px 12px;
          }
        }
      }
      @media only screen and (max-width: 1023px) {
        min-width: 100%;
        max-width: 100%;
      }
      &.mini-chat-list{
        min-width: 380px;
        max-width: 380px;
        height: 775px;
        border-right: 0;
        @media only screen and (max-width: 1640px) {
          height: 600px;
        }
        .user-list{
          &__top{
            padding: 12px 12px 8px;
          }
          &__mini-chat-header{
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 56px;
            flex: none;
            padding: 0 8px 0 16px;
            border-bottom: 1px solid var(--wc-border);
            &-count{
              min-width: 20px;
              height: 20px;
              padding: 0 6px;
              border-radius: 10px;
              background: var(--wc-accent-soft);
              color: var(--wc-accent);
              font-family: var(--wc-font-medium);
              font-size: 11px;
              line-height: 20px;
              text-align: center;
            }
            &-left{
              display: flex;
              align-items: center;
              gap: 8px;
              font-size: 16px;
              line-height: 24px;
              font-family: var(--wc-font-heading);
              font-weight: 400;
              color: var(--wc-text);
            }
            &-right{
              display: flex;
              align-items: center;
              gap: 4px;
              .link-to-chat,
              .close-mini-chat-vue{
                width: 32px;
                height: 32px !important;
                border-radius: 6px;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: background-color 0.2s;
                svg{
                  width: 20px;
                  height: 20px;
                }
                &:hover{
                  background-color: var(--wc-bg);
                }
              }
              .link-to-chat{
                height: 25px;
                &:hover{
                  svg{
                    path{
                      fill: var(--wc-text);
                    }
                  }
                }
                svg{
                  path{
                    transition: 0.3s;
                  }
                }
              }
              .close-mini-chat-vue{
                height: 25px;
                cursor: pointer;
                &:hover{
                  svg{
                    path{
                      fill: var(--wc-text);
                    }
                  }
                }
                svg{
                  path{
                    transition: 0.3s;
                  }
                }
              }
            }
          }
        }
      }
      &__top{
          padding: 16px 16px 8px;
          background-color: var(--wc-surface);
          position: relative;
          z-index: 3;
          display: flex;
          flex-direction: column;
          gap: 12px;
          @media only screen and (max-width: 767px) {
            padding: 8px 16px 12px;
          }
          &-title{
            height: 32px;
            display: flex;
            align-items: center;
            gap: 4px;
            h1{
              margin: 0;
              font-family: var(--wc-font-heading);
              font-size: 18px;
              line-height: 24px;
              font-weight: 400;
              color: var(--wc-text);
            }
            .user-list-tooltip{
              margin-left: auto;
            }
          }
          &-search{
            display: flex;
            gap: 10px;
            .search{
              width: 100%;
              position: relative;
              .input-placeholder {
                  pointer-events: none;
                  position: absolute;
                  left: 0;
                  overflow-x: hidden;
                  height: 36px;
                  padding-left: 36px;
                  display: inline-block;
                  font-family: var(--wc-font);
                  font-style: normal;
                  font-size: 13px;
                  line-height: 36px;
                  color: var(--wc-text-3);
                  user-select: none;
                  // design: "Search by username" — plain and lowercase
                  :deep(b),
                  b {
                      font-weight: 400;
                      font-family: var(--wc-font);
                      text-transform: lowercase;
                  }
              }
              button {
                  position: absolute;
                  left: 0;
                  top: 0;
                  height: 36px;
                  width: 36px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background-color: transparent;
                  border: 0;
                  padding: 0;
                  color: var(--wc-text-3);
                  z-index: 1;
                  pointer-events: none;
                  &.focus{
                    color: var(--wc-text-2);
                  }
              }
              input {
                  background-color: var(--wc-bg);
                  border: 1px solid var(--wc-border) !important;
                  border-radius: 8px;
                  box-shadow: none;
                  padding: 0 32px 0 36px;
                  height: 36px;
                  font-family: var(--wc-font);
                  font-weight: 400;
                  font-size: 13px;
                  line-height: 18px;
                  color: var(--wc-text);
                  transition: border-color 0.2s, background-color 0.2s !important;
                  &::placeholder{
                    color: var(--wc-text-3);
                  }
                  &:focus {
                      background-color: var(--wc-surface) !important;
                      border-color: var(--wc-accent-border) !important;
                      box-shadow: 0 0 0 3px rgba(78, 138, 255, 0.15);
                  }
                  @media only screen and (max-width: 1023px) {
                    height: 40px;
                  }
              }
              .filters-custom__search-filter-close{
                position: absolute;
                top: 0;
                right: 0;
                height: 36px;
                width: 32px;
                display: none;
                cursor: pointer;
                &.active{
                  display: block;
                }
                &::before,
                &::after{
                  content: '';
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  width: 12px;
                  height: 1.75px;
                  border-radius: 1px;
                  background: var(--wc-text-3);
                  transform: translate(-50%, -50%) rotate(45deg);
                }
                &::after{
                  transform: translate(-50%, -50%) rotate(-45deg);
                }
                &:hover::before,
                &:hover::after{
                  background: var(--wc-text);
                }
              }
            }
          }
          &-back{
            width: 36px;
            height: 36px;
            margin-left: -8px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }
          &-tabs{
            min-width: 260px;
          }
      }
      &__list{
        height: 100%;
        overflow-y: auto;
        user-select: none;
        display: flex;
        gap: 2px;
        flex-direction: column;
        padding: 0 8px 8px;
        @media only screen and (max-width: 767px) {
          padding: 0;
          gap: 0;
        }
        .chat-user{
          height: 64px;
          min-height: 64px;
          @media only screen and (max-width: 767px) {
            height: 72px;
            min-height: 72px;
          }
          position: relative;
          display: flex;
          max-width: 100%;
          transition: 0.3s;
          cursor: pointer;
          // &.pinned{
          //   .chat-user__wrap{
          //     background: #2B3545;
          //   }
          // }
          &.active{
            .chat-user__wrap{
              background: var(--wc-accent-soft) !important;
            }
          }
          &:hover{
            .chat-user__wrap{
              @media only screen and (min-width: 768px) {
                background: var(--wc-bg);
              }
            }
          }
          // Loading list (design S1): avatar + two bars, no time/pin placeholders
          &.skeleton-list{
            align-items: center;
            cursor: default;
            .chat-user__img{
              margin: 0 12px 0 8px;
              border-radius: 50%;
              background: #EEF0F3;
            }
            .chat-user__info{
              padding: 0 8px 0 0;
              gap: 8px;
              max-width: none;
              flex: 1;
            }
            .chat-user__info-top,
            .chat-user__info-bottom{
              height: auto;
              padding: 0;
            }
            .user-time,
            .user-pinned{
              display: none !important;
            }
            .skeleton{
              background: #EEF0F3 !important;
              border-radius: 4px;
              animation: wc-skeleton-pulse 1.4s ease-in-out infinite;
            }
            .chat-user__img.skeleton{
              border-radius: 50% !important;
            }
            .user-name.skeleton{
              width: 55% !important;
              height: 10px !important;
            }
            .user-msg.skeleton{
              width: 80% !important;
              height: 10px !important;
              background: #F2F4F6 !important;
            }
            &:nth-child(3n+2){
              .user-name.skeleton{ width: 40% !important; }
              .user-msg.skeleton{ width: 65% !important; }
            }
            &:nth-child(3n){
              .user-name.skeleton{ width: 62% !important; }
              .user-msg.skeleton{ width: 50% !important; }
            }
            &:hover .chat-user__wrap{
              background: transparent;
            }
          }
          // Row menu (design: white 184px card, 36px items, divider before Report)
          &__tooltip{
            position: absolute;
            width: 184px;
            top: 48px;
            right: 8px;
            z-index: 10;
            padding: 4px;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            border: 1px solid var(--wc-border);
            background-color: var(--wc-surface);
            box-shadow: 0 12px 32px var(--wc-shadow-strong);
            cursor: default;
            > .tooltip-body__row.pin,
            :deep(.tooltip-body__row){
              display: flex;
              align-items: center;
              gap: 10px !important;
              height: 36px;
              margin: 0;
              padding: 0 10px !important;
              border-radius: 6px;
              cursor: pointer;
              transition: background-color 0.2s;
              svg{
                width: 16px;
                height: 16px;
                min-width: 16px;
                color: var(--wc-text-2);
              }
              p{
                margin: 0;
                font-family: var(--wc-font);
                font-size: 13px;
                line-height: 18px;
                color: var(--wc-text);
              }
              &:hover{
                background: var(--wc-bg);
              }
            }
            :deep(.tooltip-body__row.report){
              margin-top: 9px;
              position: relative;
              &::before{
                content: '';
                position: absolute;
                left: 0;
                right: 0;
                top: -5px;
                height: 1px;
                background: var(--wc-surface-2);
              }
              svg,
              p{
                color: var(--wc-danger);
              }
              &:hover{
                background: var(--wc-danger-soft);
              }
            }
            .tooltip-body{
              opacity: 0;
              border-radius: 4px;
              transition: 0.3s;
              pointer-events: none;
              position: absolute;
              top: 40px;
              right: -10px;
              z-index: 15;
              box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.25);
              background: var(--wc-surface-2);
              min-width: 300px;
              &::before{
                content: "";
                position: absolute;
                right: 16px;
                top: -6px;
                width: 12px;
                height: 12px;
                background: var(--wc-surface-2);
                -webkit-transform: rotateZ(45deg);
                transform: rotateZ(45deg);
                z-index: -1;
              }
              &::after{
                content: '';
                position: absolute;
                top: -40px;
                height: 40px;
                width: 40px;
                right: 0;
                @media only screen and (max-width: 1023px) {
                  content: none;
                }
              }
              &__row{
                display: flex;
                align-items: center;
                gap: 15px;
                padding: 12px 20px;
                transition: 0.3s;
                &:first-child{
                  border-radius: 4px 4px 0 0;
                }
                &:last-child{
                  border-radius: 0 0 4px 4px;
                }
                &:hover{
                  background: var(--wc-surface);
                  svg{
                    color: var(--wc-text);
                    path{
                      fill: var(--wc-text);
                    }
                  }
                  p{
                    color: var(--wc-text);
                  }
                }
                svg{
                  color: var(--wc-text-2);
                  transition: 0.3s;
                  path{
                    transition: 0.3s;
                  }
                }
                p{
                  transition: 0.3s;
                  font-family: "Roboto-Regular", sans-serif;
                  font-weight: 400;
                  font-size: 16px;
                  white-space: nowrap;
                  line-height: 1.5;
                  color: var(--wc-text-2);
                }
              }
            }
            &.top{
              top: unset;
              bottom: 48px;
              &::before{
                top: unset;
                bottom: -6px;
              }
              &::after{
                top: unset;
                bottom: -20px;
              }
            }
            &::before{
              content: none;
            }
            &::after{
              content: '';
              position: absolute;
              top: -20px;
              left: -20px;
              height: calc(100% + 40px);
              width: calc(100% + 40px);
              right: 0;
              z-index: -1;
            }
          }
          &__wrap{
            border-radius: 8px;
            display: flex;
            min-width: 0;
            width: 100%;
            transition: 0.3s;
            align-items: center;
            z-index: 2;
            background: var(--wc-surface);
            @media only screen and (max-width: 767px) {
              border-radius: 0;
              border-bottom: 1px solid var(--wc-surface-2);
            }
            &.swiped{
              margin-left: -144px;
              border-radius: 8px 0 0 8px;
              background: var(--wc-surface);
              box-shadow: 0 4px 12px rgba(15, 23, 41, 0.1);
            }
          }
          &__btn-mobile{
            display: flex;
            justify-content: flex-end;
            z-index: 1;
            position: absolute;
            right: 1px;
            top: 1px;
            width: 144px;
            height: calc(100% - 2px);
            overflow: hidden;
            border-radius: 0 8px 8px 0;
            &.active{
              .pin{
                margin-right: 0 !important;
              }
            }
            .tooltip-body__row{
              width: 72px;
              min-width: 72px;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              :deep(p){
                display: none;
              }
              :deep(svg path){
                fill: var(--wc-on-accent);
              }
              &.pin{
                background-color: #2F6BE6;
                z-index: 2;
                transition: 0.3s;
                margin-right: -72px;
              }
              &.mute{
                background-color: var(--wc-text-2);
                border-radius: 0 8px 8px 0;
                padding: 0;
                z-index: 1;
              }
            }
          }
          &__img{
            margin: 0 12px 0 8px;
            width: 40px;
            height: 40px;
            min-width: 40px;
            min-height: 40px;
            position: relative;
            @media only screen and (max-width: 767px) {
              margin: 0 12px 0 16px;
            }
            &.skeleton{
              width: 100%;
              height: 100%;
              max-width: 40px;
              max-height: 40px;
              border-radius: 100%;
              overflow: hidden;
            }
            img{
              width: 100%;
              height: 100%;
              border-radius: 100%;
              min-height: 100%;
              overflow: hidden;
              object-fit: cover;
            }
            .user-pinned{
              position: absolute;
              right: -4px;
              bottom: -1px;
            }
            .user-count{
              position: absolute;
              right: -1px;
              top: -1px;
              margin: 0;
              width: 10px;
              height: 10px;
              border: 2px solid var(--wc-surface);
            }
            .online-status{
              position: absolute;
              right: -1px;
              bottom: -1px;
              width: 10px;
              height: 10px;
              border-radius: 100%;
              .ico-user-status{
                width: 100%;
                height: 100%;
                border-radius: 100%;
                box-sizing: border-box;
                border: 2px solid var(--wc-surface);
                background: var(--wc-online);
                opacity: 0;
                &.online{
                  opacity: 1;
                }
              }
            }
          }
          &__info{
            padding: 0 8px 0 0;
            max-width: calc(100% - 60px);
            width: 100%;
            transition: 0.3s;
            display: flex;
            flex-direction: column;
            gap: 2px;
            @media only screen and (max-width: 767px) {
              padding: 0 16px 0 0;
              max-width: calc(100% - 68px);
            }
            &-top{
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 20px;
              .top-right{
                display: flex;
                user-select: none;
                pointer-events: none;
              }
              .user-name{
                display: flex;
                align-items: center;
                min-width: 0;
                user-select: none;
                pointer-events: none;
                span{
                  min-width: 0;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  font-family: var(--wc-font-medium);
                  font-weight: 400;
                  font-size: 14px;
                  line-height: 20px;
                  color: var(--wc-text);
                }
                svg{
                  margin-left: 4px;
                  min-width: 14px;
                  width: 14px;
                  height: 14px;
                  color: var(--wc-text-3);
                }
                &.skeleton{
                  width: 78px;
                  height: 24px;
                  border-radius: 4px;
                }
              }
              .user-time{
                height: 14px;
                border-radius: 2.67px;
              }
              .user-last-msg{
                display: flex;
                align-items: center;
                svg{
                  width: 14px;
                  height: 14px;
                  color: var(--wc-text-3);
                }
                &.readed svg{
                  color: var(--wc-accent);
                }
              }
              .user-time{
                font-family: var(--wc-font);
                font-weight: 400;
                font-size: 12px;
                line-height: 16px;
                color: var(--wc-text-3);
                margin-left: 4px;
                padding-left: 4px;
                display: flex;
                align-items: center;
                white-space: nowrap;
              }
            }
            &-bottom{
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 18px;
              gap: 6px;
              .user-msg{
                display: flex;
                align-items: center;
                gap: 6px;
                min-width: 0;
                &__icon{
                  flex: none;
                  color: var(--wc-text-3);
                  &.is-system{
                    color: var(--wc-accent);
                  }
                }
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                user-select: none;
                pointer-events: none;
                &.skeleton{
                  width: 115px;
                  height: 16px;
                  display: block;
                  border-radius: 4px;
                }
                span *{
                  display: inline;
                  white-space: nowrap;                  
                }
                span{
                  font-family: var(--wc-font);
                  font-weight: 400;
                  font-size: 13px;
                  line-height: 18px;
                  color: var(--wc-text-2);
                  white-space: nowrap;
                  text-wrap: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  max-width: 100%;
                  display: inline;
                  max-height: 22px;
                  &.unrid{
                    color: var(--wc-text);
                    font-family: var(--wc-font-medium);
                  }
                  :deep(a) {
                    display: inline;
                    height: 17px;
                    color: inherit;
                    padding: 0 2px;
                    pointer-events: none;
                  }
                  &.not-msg{
                    color: var(--wc-text-3);
                  }
                }
              }
              .user-right-icon{
                display: flex;
                align-items: center;
                gap: 6px;
              }
            }
          }
          // Unread marker is a dot in the design; the API only says read / not read
          .user-count{
            display: block;
            width: 8px;
            height: 8px;
            min-width: 8px;
            padding: 0;
            border-radius: 50%;
            background: var(--wc-accent-2);
            font-size: 0;
            line-height: 0;
            color: transparent;
            overflow: hidden;
          }
          .user-pinned{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 14px;
            height: 14px;
            svg{
              width: 14px;
              height: 14px;
              color: var(--wc-text-3);
            }
          }
        }
      }
      &__result-text{
        padding: 24px;
        // the site's global ".empty" paints a "not found" illustration; not in the chat
        &.empty{
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: none !important;
          min-height: 0 !important;
        }
        // search with no results and empty tabs sit at the top of the list (design S4)
        &.is-tab.empty,
        &.is-search.empty{
          height: auto;
          align-items: flex-start;
          padding-top: 48px;
        }
        &-empty{
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 8px;
          max-width: 260px;
          .user-list__retry{
            margin-top: 8px;
            height: 32px;
            padding: 0 14px;
            border: 1px solid var(--wc-border);
            border-radius: 8px;
            background: var(--wc-surface);
            color: var(--wc-text);
            font-family: var(--wc-font-medium);
            font-size: 13px;
            line-height: 18px;
            cursor: pointer;
            transition: background-color 0.2s;
            &:hover{
              background: var(--wc-bg);
            }
          }
          text-align: center;
          svg{
            margin-bottom: 4px;
          }
          .title{
            font-family: var(--wc-font-heading);
            font-weight: 400;
            font-size: 15px;
            line-height: 20px;
            color: var(--wc-text);
            padding-bottom: 0;
          }
          p{
            margin: 0;
            font-family: var(--wc-font);
            font-weight: 400;
            font-size: 13px;
            line-height: 18px;
            text-align: center;
            color: var(--wc-text-2);
          }
        }
        span{
          display: block;
          text-align: center;
          font-family: "Roboto-Regular";
          font-size: 14px;
          line-height: 19.6px;
          color: var(--wc-text-3);
        }
      }
    .skeleton{
        // background: linear-gradient(
        //     90deg,
        //     var(--wc-skeleton-1) 0% 25%,
        //     #242c3a 50%,
        //     var(--wc-skeleton-1) 65% 100%
        // );
        border-radius: 4px;
        width: 100%;
        display: block;
        //animation: 1s wave-placeholder infinite linear !important;
        background-size: 200% !important;
    }
    .skeleton-light{
        // background: linear-gradient(
        //     90deg,
        //     #354051 0% 25%,
        //     var(--wc-skeleton-1) 50%,
        //     #354051 65% 100%
        // );
        border-radius: 4px;
        width: 100%;
        display: block;
        //animation: 1s wave-placeholder infinite linear !important;
        background-size: 200% !important;
    }
    @keyframes wave-placeholder {
        from {
            background-position: 100% 0%;
        }
        to {
            background-position: -100% 0%;
        }
    }
  }

@keyframes wc-skeleton-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.55; }
}
</style>
